module.exports = __webpack_public_path__ + "static/amina-2b982e52c9e0a9d47e6d6a8f71848e4f.png";